import { forwardRef, type SVGProps } from 'react';

export interface DiveMaskProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

/**
 * Dive mask icon in Lucide style (24x24 viewBox, currentColor stroke).
 * Used as the "Mein Tauchen" navigation icon.
 */
export const DiveMask = forwardRef<SVGSVGElement, DiveMaskProps>(
  ({ size = 24, strokeWidth = 2, className, ...rest }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth as number}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* Mask body with V-notch nose pocket */}
      <path d="M6 4h6a5 5 0 0 1 0 10h-1l-2.5-2.5L6 14a5 5 0 0 1 0-10z" />
      {/* Snorkel tube */}
      <path d="M21 3v14a3 3 0 0 1-3 3h-4" />
      {/* Mouthpiece */}
      <rect x="8" y="17" width="6" height="5" rx="1" />
    </svg>
  ),
);

DiveMask.displayName = 'DiveMask';

export default DiveMask;